export default __webpack_public_path__ + "static/modern-development-framework-dbaf4140a007e1e00c9cea79ee8f39ae.svg";